// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"f325e0dd","285":"813e0402","371":"3a38836f"}[chunkId] + ".chunk.js";
};